import Header from '../../../__Layout/Header';
import React,{useState} from "react";
import Loader from '../../../utils/Loader';
import "../../../assets/niceapms/assets/css/style.css"
import {Link, useParams } from 'react-router-dom';
import { usePlayVideoQuery} from "../../../Services/api";
import {pageUrl} from "../../../utils/constants/constants";

export default function VideoPlay() {   
    const { video } = useParams();
    const { 
        data: PlayVideo,
        isLoading: isGetLoading,
    } = usePlayVideoQuery({ pageUrl, params: video });

   if(isGetLoading) return  <Loader></Loader>
    return ( 
        <>
            <Header />
            <main id="main" className="main">
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title">Video Played</h5>
                        <section className="section">
                            <div className="row">
                              <div className='col-12'>
                              <video width="750" height="500" controls controlsList="nodownload"  >
                                    <source src={PlayVideo?.data?.video} type="video/mp4"/>
                                </video>
                              </div>
                            </div>
                        </section>  
                    </div>

                </div>
            </main>
        </>
    );
}
